import React from 'react';
import ServicePage from './ServicePage';
import { IconWind, IconShield, IconAlertTri } from '../../components/Icons';

const DATA = {
  icon: <IconWind size={32} />, category: 'mineria',
  title: 'Planes de Ventilación',
  subtitle: 'Diseño de sistemas de ventilación para garantizar aire limpio y seguro en labores subterráneas.',
  norm: 'Decreto 1886 de 2015 – Art. 153 a 178',
  desc: 'Elaboramos planes de ventilación técnicos y normativos para minas subterráneas. Realizamos diagnósticos, modelaciones y diseño de redes para garantizar condiciones de aire seguras y saludables para los trabajadores, cumpliendo rigurosamente el Decreto 1886 de 2015.',
  details: [
    'Diagnóstico del sistema de ventilación actual',
    'Modelación y simulación de flujos de aire',
    'Diseño de redes de ventilación principal y auxiliar',
    'Cálculo de requerimientos de ventiladores principales',
    'Plan de emergencia por falla de ventilación',
    'Informe técnico y normativo para la ANM',
  ],
  related: [
    { icon: <IconShield size={18} />,   label: 'Planes de Sostenimiento',   path: '/servicios/sostenimiento' },
    { icon: <IconAlertTri size={18} />, label: 'Prevención Metano y Polvo', path: '/servicios/metano-polvo' },
  ],
};

export default function Ventilacion() { return <ServicePage data={DATA} />; }
